//Action Types
export const SET_SESSION_DATA = "SET_SESSION_DATA"
export const GET_SESSION_DATA = "GET_SESSION_DATA"
export const SET_USER_SESSION_DATA = "SET_USER_SESSION_DATA"
export const SET_PUBLIC_API_KEY = "SET_PUBLIC_API_KEY"
export const SET_IS_ERROR = "SET_IS_ERROR"
export const SET_COLLAPSED = "SET_COLLAPSED"
export const SET_IS_PROJECT = "SET_IS_PROJECT"

//Action Creator
export const setSessionData = (payload) => async (dispatch) => {
  dispatch({
    type: SET_SESSION_DATA,
    payload
  })
}

export const setCollapsed = (payload) => async (dispatch) => {
  dispatch({
    type: SET_COLLAPSED,
    payload
  })
}

export const setUserSessionData = (payload) => async (dispatch) => {
  dispatch({
    type: SET_USER_SESSION_DATA,
    payload
  })
}
//Action Creator
export const getSessionData = () => async (dispatch) => {
  dispatch({
    type: GET_SESSION_DATA
  })
}

export const setPublicKey = (payload) => async (dispatch) => {
  dispatch({
    type: SET_PUBLIC_API_KEY,
    payload
  })
}

export const setIsAcess = (payload) => async (dispatch) => {
  dispatch({
    type: SET_IS_ERROR,
    payload
  })
}

export const setProjectName = (payload) => async (dispatch) => {
  dispatch({
    type: SET_IS_PROJECT,
    payload
  })
}